import Cookies from 'js-cookie'

export const getClerkSessionFromCookie = () => {
  return Cookies.get('__session')
}
